import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "divider"
}
const _hoisted_2 = {
  key: 1,
  role: "presentation",
  class: "dropdown-header"
}
const _hoisted_3 = ["href", "title"]
const _hoisted_4 = {
  key: 0,
  class: "divider"
}
const _hoisted_5 = {
  key: 1,
  role: "presentation",
  class: "dropdown-header"
}
const _hoisted_6 = ["href", "title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_btn = _resolveComponent("btn")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.scmExport?.enabled)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (_ctx.scmExport?.actions)
            ? (_openBlock(), _createElementBlock("li", _hoisted_1))
            : _createCommentVNode("", true),
          (_ctx.scmExport?.actions)
            ? (_openBlock(), _createElementBlock("li", _hoisted_2, [
                _cache[4] || (_cache[4] = _createElementVNode("i", { class: "glyphicon glyphicon-circle-arrow-right" }, null, -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.$t("scm.export.actions.title")), 1)
              ]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.scmExport?.actions, (action) => {
            return (_openBlock(), _createElementBlock("li", null, [
              _createElementVNode("a", {
                href: _ctx.jobPageStore.createProjectScmActionHref(action.id, 'export'),
                title: action.description
              }, _toDisplayString(action.title), 9, _hoisted_3)
            ]))
          }), 256))
        ], 64))
      : _createCommentVNode("", true),
    (_ctx.scmImport?.enabled)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (_ctx.scmImport?.actions)
            ? (_openBlock(), _createElementBlock("li", _hoisted_4))
            : _createCommentVNode("", true),
          (_ctx.scmImport?.actions)
            ? (_openBlock(), _createElementBlock("li", _hoisted_5, [
                _cache[5] || (_cache[5] = _createElementVNode("i", { class: "glyphicon glyphicon-circle-arrow-left" }, null, -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.$t("scm.import.actions.title")), 1)
              ]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.scmImport?.actions, (action) => {
            return (_openBlock(), _createElementBlock("li", null, [
              _createElementVNode("a", {
                href: _ctx.jobPageStore.createProjectScmActionHref(action.id, 'import'),
                title: action.description
              }, _toDisplayString(action.title), 9, _hoisted_6)
            ]))
          }), 256))
        ], 64))
      : _createCommentVNode("", true),
    (
      _ctx.authProjectSCMAdmin && (_ctx.scmImport?.configured || _ctx.scmExport?.configured)
    )
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          _cache[6] || (_cache[6] = _createElementVNode("li", { class: "divider" }, null, -1)),
          _createElementVNode("li", null, [
            _createElementVNode("a", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleModal = true))
            }, _toDisplayString(_ctx.$t(`job.toggle.scm.menu.${_ctx.enabledStatus ? "off" : "on"}`)), 1)
          ]),
          (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
            _createVNode(_component_modal, {
              modelValue: _ctx.toggleModal,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.toggleModal) = $event)),
              title: _ctx.$t('job.toggle.scm.confirm.panel.title')
            }, {
              footer: _withCtx(() => [
                _createVNode(_component_btn, {
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleModal = false))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("no")), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_btn, {
                  type: "danger",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.actionToggleScm(!_ctx.enabledStatus)))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t(`job.toggle.scm.button.label.${_ctx.enabledStatus ? "off" : "on"}`)), 1)
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _createElementVNode("p", null, _toDisplayString(_ctx.$t(`job.toggle.scm.confirm.${_ctx.enabledStatus ? "off" : "on"}`)), 1)
              ]),
              _: 1
            }, 8, ["modelValue", "title"])
          ]))
        ], 64))
      : _createCommentVNode("", true)
  ], 64))
}